import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'
import styled from 'styled-components'
import { withRouter } from 'react-router-dom'
import { injectIntl } from 'react-intl'
import useGetConfigurator from 'core/hooks/useGetConfigurator'
import * as routes from 'core/routing/constants/index'
import MainContentWrapper from 'core/templates/MainContentWrapper'
import wizardsShape from 'core/components/wizard/shapes'
import PageLoading from 'core/components/page-loading'
import { Row, Empty } from 'core/components/ui'
import { configuratorShape } from '../shapes'
import ModelItem from './model-item'

const ModelWrapper = styled(Row)``

const renderList = modelsList =>
  modelsList.map(model => (
    <ModelItem model={model} key={model.name} data-test="configurator-models-model-item" />
  ))

const Models = props => {
  const { configurator, setConfigurator, intl, setWizards, wizards, history } = props

  const { loading, getModels, models } = useGetConfigurator({
    redirectMessage: intl.formatMessage({ id: 'ui-session-expired' })
  })

  const { brand, modelGroup, modelsList, model } = configurator

  const desactivateNextStep = () => {
    const aStepsActive = wizards[wizards.activeWizard]
    const nextIndex = aStepsActive.findIndex(step => step.hash === routes.CONFIGURATOR_MODELS) + 1

    const extendedStep = { ...aStepsActive[nextIndex], isActive: false }

    const extendedSteps = Object.assign([...aStepsActive], {
      [nextIndex]: extendedStep
    })
    const extentedWizards = { ...wizards, aStepsConfigurator: extendedSteps }
    setWizards(extentedWizards)
  }

  useEffect(() => {
    const runIt = list => {
      setConfigurator({
        ...configurator,
        modelsList: list
      })
    }
    if (models) runIt(models)
  }, [models])

  useEffect(() => {
    // Redirection if direct access & step is not active

    const aStepsActive = wizards[wizards.activeWizard]

    const extendedStepsActive = aStepsActive.filter(
      step => step.hash === routes.CONFIGURATOR_MODELS
    )
    const currentStep = extendedStepsActive[0]

    const { isActive } = currentStep

    if (!isActive) {
      history.push(routes.HOME)
    }

    if (!model) desactivateNextStep()

    const params = {
      brand: brand.id,
      groupModel: modelGroup.id
    }
    getModels(params)
  }, [])

  const subTitle = `${brand.name} ${modelGroup.name}`

  return (
    <MainContentWrapper
      title={intl.formatMessage({ id: 'configurator-models-view-title' })}
      subTitle={subTitle}
      data-test="component-configurator-models"
    >
      {loading && !modelsList ? (
        <PageLoading data-test="configurator-models-loading" />
      ) : (
        <ModelWrapper
          type="flex"
          justify="center"
          align="middle"
          gutter={16}
          data-test="configurator-models-model-wrapper"
        >
          {modelsList ? renderList(modelsList) : <Empty />}
        </ModelWrapper>
      )}
    </MainContentWrapper>
  )
}

Models.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  intl: PropTypes.shape().isRequired,
  setWizards: PropTypes.func.isRequired,
  wizards: wizardsShape.isRequired,
  configurator: configuratorShape.isRequired,
  setConfigurator: PropTypes.func.isRequired
}

export default withRouter(injectIntl(Models))
